import axios from 'axios'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getBackendUrl } from '../../../api'
import { useSnackbar } from '../../../providers/SnackbarProvider'

const SERVER_URL = getBackendUrl()
export const useBookingById = () => {
    const [selectedTab, setSelectedTab] = useState('info')
    const [booking, setBooking] = useState()
    const { bookingId } = useParams()

    const handelTabChange = useCallback((e, val) => {
        setSelectedTab(val)
    }, [])
    const { showSnackbar } = useSnackbar()
    const fetchData = useCallback(async () => {
        try {
            const { data } = await axios.get(`${SERVER_URL}/customers/bookings/${bookingId}`)
            setBooking(data.payload)
        } catch (errors) {
            showSnackbar({
                msg: errors.response.data.developerInfo,
                sev: 'error',
            })
        }
    }, [bookingId, showSnackbar])

    useEffect(() => {
        fetchData()
    }, [fetchData])
    return useMemo(
        () => ({
            booking: booking,
            selectedTab: selectedTab,
            handelTabChange: handelTabChange,
        }),
        [selectedTab, handelTabChange, booking]
    )
}
